/**
 * Return the height of the main header + mobile app header.
 *
 * @param {import('src/types/app-store').AppStoreState} state
 * @param {import('src/types/app-store').AppStoreGetters} getters
 */
export function appHeaderHeight(state) {
  return state.mainHeaderHeight + state.pageHeaderHeight;
}

/**
 * @param {import('src/types/app-store').AppStoreState} state
 */
export function isZubieDialogOpen(state) {
  return state.openDialogCount > 0;
}
